import { officialNotices } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function OfficialNoticesSection() {
  return (
    <section id="notices" className="border-y border-background-200 bg-secondary-50">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
            <div>
              <span className="flex items-center gap-2 text-xs text-secondary-700">
                <i className="ri-government-line" />
                权威来源 · 原文可溯
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                官方通报
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              只收录监管部门、平台方与行业协会的公开发布，标注来源与时间，第一时间同步。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {officialNotices.map((notice, index) => (
            <Reveal key={notice.title} delay={index * 90}>
              <article className="flex h-full flex-col rounded-lg border border-secondary-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2 text-xs font-medium text-secondary-800">
                    <i className="ri-verified-badge-line text-secondary-600" />
                    {notice.org}
                  </span>
                  <span className="text-[11px] text-foreground-500">{notice.date}</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                  {notice.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {notice.summary}
                </p>
                <a
                  href="#notices"
                  className="mt-auto flex items-center gap-1 pt-5 text-sm font-medium text-secondary-700 hover:text-secondary-900"
                >
                  查看通报原文
                  <i className="ri-arrow-right-s-line" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}